import { useEffect } from 'react';
import { MapLocationData } from '@hero/web-components';

export interface UseMapAutoFitOptions {
  /** Whether to auto-fit bounds */
  autoFitMarkerBounds: boolean;
  /** Map instance */
  map: google.maps.Map | null;
  /** Locations to fit */
  locations: MapLocationData[];
  /** Fit bounds function */
  fitBounds: (map: google.maps.Map, locations: MapLocationData[]) => void;
}

/**
 * Hook for auto-fitting map bounds when locations change
 */
export function useMapAutoFit({
  autoFitMarkerBounds,
  map,
  locations,
  fitBounds,
}: UseMapAutoFitOptions) {
  // Fit bounds when locations change
  useEffect(() => {
    if (autoFitMarkerBounds && map && locations.length > 0) {
      const timeoutId = setTimeout(() => {
        fitBounds(map, locations);
      }, 100);

      return () => clearTimeout(timeoutId);
    }
    return undefined;
  }, [autoFitMarkerBounds, map, locations.length, fitBounds]);
}
